import { render, staticRenderFns } from "./fba-shipment-copy.vue?vue&type=template&id=1052604e&scoped=true&"
import script from "./fba-shipment-copy.vue?vue&type=script&lang=js&"
export * from "./fba-shipment-copy.vue?vue&type=script&lang=js&"
import style0 from "./fba-shipment-copy.vue?vue&type=style&index=0&id=1052604e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052604e",
  null
  
)

export default component.exports